function getProduct(item) {
    return $.ajax({dataType: "json", url: '/products/' + item.handle + '.js', async: false}).responseJSON;
}

function getCartProducts() {
    const cartItems = $.ajax({
        dataType: "json",
        url: '/cart.js',
        async: false
    }).responseJSON.items;

    return cartItems.map(item => getProduct(item));
}

function isTargetProduct(targetTag, product) {
    let result = false;
    const capitalTargetTag = targetTag.toUpperCase();
    for(const tag of product['tags']) {
        const capitalTag = tag.toUpperCase();
        if (capitalTag === capitalTargetTag) {
            result = true;
            break;
        }
    }
    return result;
}

function filterTargetProducts(targetTag, products) {
    const results = [];
    for (const product of products) {
        if (isTargetProduct(targetTag, product)) {
            results.push(product);
        }
    }
    return results;
}

function isGiftCard(product) {
    return product.type === "ギフトカード";
}

function filterGiftCards(products) {
    const results = [];
    for (const product of products) {
        if (isGiftCard(product)) results.push(product);
    }
    return results;
}

function filterSubscriptions(products) {
    const results = [];
    for (const product of products) {
        if(product.hasOwnProperty("selling_plan_groups") &&
            product.selling_plan_groups.length > 0) {
            results.push(product);
        }
    }
    return results;
}

const reservationTag = "予約商品";
const megaSportsTag = "megasports";
const alcoholTag = "BEER-APPLY";

// 閲覧中のページの商品をカートに追加できる場合はtrue
function validateAddToCart(isReserved, isGiftCard, isMegaSports, isAlcohol) {
    let result = {
        result: true,
        message: ""
    };

    /** アルコール同意 */
    if(isAlcohol) {
        const $alcoholCheck = $('input[name="alcohol_check"]');
        if($alcoholCheck.length) {
            const checked = $alcoholCheck.prop('checked');
            if(!checked) {
                result = {
                    result: false,
                    message: alertMessage.alcohol_checkbox
                };
                return result;
            }
        }
    }

    const cartProducts = getCartProducts();

    /** カート内の商品が0個ならtrue */
    if (cartProducts.length) {

        /**
         * サブスク商品チェック
         *
         * 以下はtrue
         * - サブスク商品ではない && サブスク商品を含まない
         * - サブスク商品である && サブスク商品を含む
         */
        const isSubscription　= $('input[name="selling_plan"]').length > 0;
        let includeSubscription = false;
        const subscriptionProducts = filterSubscriptions(cartProducts);
        if(subscriptionProducts.length) {
            includeSubscription = true;
        }

        if(!(isSubscription === includeSubscription)) {
            result = {
                result: false,
                message: alertMessage.subscription
            };
        }
        if(!result.result) return result;

        /**
         * 予約商品チェック
         * 以下はtrue
         * - 予約商品ではない && 予約商品を含まない
         * - 予約商品である && 予約商品を含む
         */
        const reservationProducts = filterTargetProducts(reservationTag, cartProducts);
        const includeReservationItem = reservationProducts.length > 0; //予約商品を含んでいたらtrue;
        if(!(isReserved === includeReservationItem)) {
            result = {
                result: false,
                message: alertMessage.reserved
            };
        }
        if(!result.result) return result;

        /**
         * メガスポーツチェック
         */
        const megaSportsProducts = filterTargetProducts(megaSportsTag, cartProducts);
        const includeMegaSportsItem = megaSportsProducts.length > 0; //メガスポーツを含んでいる場合はtrue
        if(!(isMegaSports === includeMegaSportsItem)) {
            result = {
                result: false,
                message: alertMessage.megaSports
            };
        }
        if(!result.result) return result;

        /**
         * アルコールチェック
         */
        const alcoholProducts = filterTargetProducts(alcoholTag, cartProducts);
        const includeAlcoholItem = alcoholProducts.length > 0; //アルコールを含んでいる場合はtrue
        if(!(isAlcohol === includeAlcoholItem)) {
            result = {
                result: false,
                message: alertMessage.alcohol
            };
        }
        if(!result.result) return result;

        /**
         * ギフトカードチェック
         */
        const giftCards = filterGiftCards(cartProducts);
        const includeGiftCard = giftCards.length > 0; //ギフトカードを含んでいる場合はtrue
        if(!(isGiftCard === includeGiftCard)) {
            result = {
                result: false,
                message: alertMessage.giftCard
            };
        }
    }

    return result;
}

function validateCartItems() {
    let result = {
        result: true,
        message: ""
    };

    const cartProducts = getCartProducts();

    if (cartProducts) {

        /** サブスク商品 */
        const subscriptionProducts = filterSubscriptions(cartProducts);
        if(subscriptionProducts.length) {
            if(subscriptionProducts.length !== cartProducts.length) {
                result = {
                    result: false,
                    message: alertMessage.subscription
                };
            }
        }
        if(!result) return result;

        /** 予約 */
        const reservationProducts = filterTargetProducts(reservationTag, cartProducts);
        if(reservationProducts.length) {
            if( reservationProducts.length !== cartProducts.length) {
                result = {
                    result: false,
                    message: alertMessage.reserved
                };
            }
        }
        if(!result) return result;

        /** メガスポーツ */
        const megaSportsProducts = filterTargetProducts(megaSportsTag, cartProducts);
        if(megaSportsProducts.length) {
            if(megaSportsProducts.length !== cartProducts.length) {
                result = {
                    result: false,
                    message: alertMessage.megaSports
                };
            }
        }
        if(!result) return result;

        /** アルコールチェック */
        const alcoholProducts = filterTargetProducts(alcoholTag, cartProducts);
        if(alcoholProducts.length) {
            if(alcoholProducts.length !== cartProducts.length) {
                result = {
                    result: false,
                    message: alertMessage.alcohol
                };
            }
        }
        if(!result) return result;

        /** ギフトカード */
        const giftCards = filterGiftCards(cartProducts);
        if(giftCards.length) {
            if(giftCards.length !== cartProducts.length) {
                result = {
                    result: false,
                    message: alertMessage.giftCard
                };
            }
        }
        if(!result) return result;
    }

    return result;
}

function validateCheckout() {
    const result = validateCartItems();
    if(!result.result) {
        alert(result.message);
    }
    return result.result;
}

function initCardVariantButtons() {
    const $productCardVariantButtons = $(".product-card__variant-button");

    if($productCardVariantButtons.length) {
        $productCardVariantButtons.on("click", function() {
            const $button = $(this);

            if($button.hasClass("current")) {
                return;
            }

            const sectionId = $button.data("section-id");
            const productId = $button.data("product-id");
            const $media = $(".media-" + sectionId + "-" + productId);

            if(productId && $media.length) {
                $(".variant-button-" + productId).removeClass("current");
                $button.addClass("current");

                const $variantImageData = $button.find(".variant-image-data");

                if($variantImageData.length) {
                    const src = $variantImageData.attr("src");
                    const srcset = $variantImageData.attr("srcset");
                    const sizes = $variantImageData.attr("sizes");

                    $media.attr("src", src);
                    $media.attr("srcset", srcset);
                    $media.attr("sizes", sizes);
                }
            }
        });
    }
}

const $smallPackage = $("#smallPackage");
const $largePackage = $("#largePackage");
function changeShippingFee(variant) {
    console.log("changeShippingFee", variant);
    if(variant) {
        if($smallPackage.length && $largePackage.length) {
            if(variant.weight > 100) {
                $smallPackage.hide();
                $largePackage.show();
            } else {
                $smallPackage.show();
                $largePackage.hide();
            }
        }
    }
}

setTimeout(function (){
    initCardVariantButtons();
}, 2000);